import {React, useState} from 'react'
import useUser from '../../hooks/useUser'


import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import {LinearProgress} from '@mui/material';


import{
    EyeIcon,    
    ArrowDownTrayIcon
}from "@heroicons/react/24/outline"

import axios from 'axios';
import WriteLog from '../Globals/WriteLog';
import useLocation from '../../hooks/useLocation';
import Spinner from 'react-bootstrap/Spinner';
import useReport from '../../hooks/useReport';

function Report({addrSeq}) {       
    
    //user info
    const { user } = useUser();
        
    //report
    const {reports} = useReport(user?.customer_code, user?.token, addrSeq)
    WriteLog("Report->reports", reports);
    var woHistor = reports?.wo_history
    WriteLog("Report->woHistor", woHistor);

    //location
    const { locations } = useLocation(user?.customer_code, user?.token);                
    WriteLog("Report->locations", locations);
    var location = locations?.locations?.filter(l=> l.AddrSeq == addrSeq);
    if(location?.length>0) location = location[0];
    WriteLog("Report->location", location);

    // //job category
    // const {jobCategories} = useJobCategory(user?.token);    
    // const [jobCategory, setJobCategory] = useState("")    
    // const handleJobCategoryChange = (e) => {                
    //     setJobCategory(e.target.value);
    // };    
        
    // if(jobCategory != "")
    //     {   
    //         WriteLog("Report-Filter->wo_history", reports)     
    //         woHistor = reports?.wo_history?.filter((r)=> r.jobCategory == jobCategory);
    //         WriteLog("Report-Filter->woHistor", woHistor)
    //     }   
    // WriteLog("Report->jobCategories", jobCategories?.JobCategories);

    

    // //reports
    // const fetcher = Fetcher();    
    // WriteLog("useReport->Endpoint",process.env.NEXT_PUBLIC_SERVER_BASE_URL +'/work_order/history/'+ user?.data?.customer_code +'?addr_seq='+addrSeq);
    // const { data, error } = useSWR([process.env.NEXT_PUBLIC_SERVER_BASE_URL +'/work_order/history/'+ user?.data?.customer_code+'?addr_seq='+addrSeq, 
    //     {   method: 'GET',
    //         headers: {
    //                     'Authorization': user?.token,
    //                 }
    //     }
    // ], fetcher)
    // const reports = data;

    WriteLog("Report->reports", reports);
    //Table
    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
          backgroundColor: "#DDD",
          color: theme.palette.common.black,   
          height:60       
        },
        [`&.${tableCellClasses.body}`]: {          
          border:'3px solid #FFF',           
          height:50,
          padding:5,
          margin:0  
        },
        [`&.${tableCellClasses.root}`]: {            
            border:'3px solid #FFF',            
          },        
          [`&.${tableCellClasses.hover}`]: {            
            backgroundColor: "#0F0",
          },        
      }));
    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        "&:nth-of-type(odd)": {
            backgroundColor: theme.palette.action.hover,   
                     
        },       
        //hide last border
        // "&:last-child td, &:last-child th": {
        //     border: 0,
        // },
    }));
    function convertUTCDateToLocalDate(date) {
        var newDate = new Date(date.getTime()+date.getTimezoneOffset()*60*1000);    
        var offset = date.getTimezoneOffset() / 60;
        var hours = date.getHours();    
        newDate.setHours(hours - offset);    
        return newDate;   
    }
    
    function base64ToArrayBuffer (base64) {
        const binaryString = window.atob(base64); // Comment this if not using base64
        const bytes = new Uint8Array(binaryString.length);
        return bytes.map((byte, i) => binaryString.charCodeAt(i));
        }
    
    const saveFile = async (blob) => {
        const a = document.createElement('a');
        a.download = 'my-file.pdf';
        a.href = URL.createObjectURL(blob);  
        a.addEventListener('click', (e) => {
            setTimeout(() => URL.revokeObjectURL(a.href), 30 * 1000);
          }); 
        a.click()
        WriteLog("File Saved");     
      };
    
    const previewReport = async (e, WoId) =>{    
        e.preventDefault();
        WriteLog("WorkOrder->WoId", WoId);
        WriteLog("WorkOrder->token", user?.token );
        setPreViewLoading(true)
        await axios.get(process.env.NEXT_PUBLIC_SERVER_BASE_URL +'/work_order/report/preview?id='+WoId,    
            {                
                headers: {                
                    'Authorization':user?.token,                    
                },
            }
            ).then(function (res){
                    setPreViewLoading(false)
                    console.log("PreviewReport->data", res.data);                      
                    var file = new Blob([base64ToArrayBuffer(res.data)], { type: 'application/pdf' });                    
                    var fileURL = URL.createObjectURL(file);                    
                    window.open(fileURL); 
                    //  console.log("PreviewReport->data", res.data);                      
                    // var file = new Blob([base64ToArrayBuffer(res.data)], { type: 'application/pdf' });                    
                    // var fileURL = URL.createObjectURL(file);                    
                    // console.log("PreviewReport->fileURL->", fileURL);
                    // window.open(fileURL);                                       
                   
                }).catch(function(error){
                    setPreViewLoading(false)
                    console.log("PreviewReport->Error->", error);
            });
    }

    const DownloadReport = async (e, WoId) =>{    
        e.preventDefault();
        WriteLog("WorkOrder->WoId", WoId);
        WriteLog("WorkOrder->token", user?.token );
        setPreViewLoading(true)
        await axios.get(process.env.NEXT_PUBLIC_SERVER_BASE_URL +'/work_order/report/preview?id='+WoId,    
            {                
                headers: {                
                    'Authorization':user?.token,                    
                },
            }
            ).then(function (res){
                setPreViewLoading(false)
                    // console.log("PreviewReport->data", res.data);                      
                     var file = new Blob([base64ToArrayBuffer(res.data)], { type: 'application/pdf' });                    
                    // var fileURL = URL.createObjectURL(file);                    
                    // window.open(fileURL);                                       
                   saveFile(file);                                        
                }).catch(function(error){
                    setPreViewLoading(false)
                    WriteLog("PreviewReport->Error->", error);
            });
    }

    //loading
    const [preViewLoading, setPreViewLoading] = useState(false)    
    
    return (              
        <div className="flex-grow h-screen overflow-y-auto bg-white"> 
            <div className='flex pl-5 pt-5 items-center space-x-3'>
                <div className='text-2xl font-bold'>Inspection Reports:</div>        
                <div className='flex h-8 w-8 shrink-0 grow-0 items-center justify-center rounded-full bg-gray-300'>
                    {woHistor?.length}
                </div>
            </div>
            <div className='flex ml-10 mt-5 items-center  justify-between'>
                <div className='flex items-baseline space-x-2'>
                    <div className='text-xl font-bold'>Location:</div>
                    <div className='text-sm'>{addrSeq>=0?location?.Name:"All"}</div>                    
                </div>                
                {/* <div className='border mr-10'>
                    <ThemeProvider theme={theme}>
                        <FormControl sx={{ m:0, p:0, minWidth: 200 }}>                            
                            <Select                                
                                value={jobCategory}                            
                                onChange={handleJobCategoryChange}>                                                                        
                                    {jobCategories?.JobCategories?.map((jb)=>(
                                    <MenuItem value={jb.id}>{jb.name}</MenuItem>
                                ))}                                                                
                            </Select>
                        </FormControl>
                    </ThemeProvider>                     
                </div>                 */}
            </div>                              
            <div className='pl-10 pt-1 pr-10'>
                {!reports &&
                    <LinearProgress color='primary' />
                }
            </div>
            <div className='pl-10 pt-1 pr-10'>                                  
                <TableContainer component={Paper}>
                <Table> 
                    <colgroup>
                        <col width="10%" />
                        <col width="20%" />
                        <col width="25%" />
                        <col width="15%" />
                        <col width="15%" />
                        <col width="10%" />
                    </colgroup>
                    <TableHead>
                        <TableRow>
                            <StyledTableCell align="left">WO #</StyledTableCell>
                            <StyledTableCell align="left">Date</StyledTableCell>                            
                            <StyledTableCell align="left">Description</StyledTableCell>                            
                            <StyledTableCell align="center">Location</StyledTableCell>
                            <StyledTableCell align="center">Tech.</StyledTableCell>
                            <StyledTableCell align="center">
                                <div className='flex space-x-2 items-center justify-center'>
                                    <div>
                                        {preViewLoading &&
                                            <Spinner animation="grow" size='sm' />
                                        }
                                    </div>
                                    <div className='text-center'>Report</div>
                                </div>
                                 </StyledTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                    {woHistor?.map((wo) => (              
                        <StyledTableRow key={`${wo.serv_order}_${wo.addr_seq}`}>
                            <StyledTableCell align="left">
                                <div className='flex justify-left h-full items-center space-x-2'>
                                    <div className='h-full w-1' style={{backgroundColor:wo.job_cat_color}}></div>                                    
                                    <div className="text-gray-500 text-sm">{wo.serv_order}</div>
                                </div>
                                </StyledTableCell>
                            <StyledTableCell align="left">
                                {wo.sched_date !== "" && 
                                    <div className="text-gray-600 text-sm">                                
                                        {
                                        new Intl.DateTimeFormat("en-GB", {
                                            year: "numeric",
                                            month: "long",
                                            day: "2-digit",
                                            hour: 'numeric', 
                                            minute: 'numeric',                                     
                                            hour12: true,
                                        }).format(convertUTCDateToLocalDate(new Date(wo.sched_date)))}                                                                
                                    </div>
                                }
                            </StyledTableCell>                             
                            <StyledTableCell align="left"><div className="text-gray-500 text-sm">{wo.wo_description}</div></StyledTableCell>
                            <StyledTableCell align="left"><div className="text-gray-500 text-sm">{wo.location_name}</div></StyledTableCell>
                            <StyledTableCell align="center"><div className="text-gray-500 text-sm">{wo.tech_name}</div></StyledTableCell>
                            <StyledTableCell align="center">
                                
                                {wo.ins_prpt_release === 1 &&
                                    <div className='flex justify-evenly text-gray-400 cursor-pointer'>
                                    <EyeIcon className='w-6 h-6 hover:text-gray-700' onClick={(e)=>previewReport(e, wo.serv_order)} />                                    
                                    <ArrowDownTrayIcon className='w-6 h-6 hover:text-gray-700' onClick={(e)=>DownloadReport(e, wo.serv_order)} />
                                    </div>
                                }
                                {wo.ins_prpt_release == 0 &&
                                    <div className='bg-orange-400 text-white rounded-lg p-0'>
                                        InProcess
                                    </div>
                                }                                                                             
                            </StyledTableCell>                            
                        </StyledTableRow>
                    ))}
                    
                    </TableBody>

                </Table>
                </TableContainer>
            </div>
        </div>
    )
}
export default Report